import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import MachineFuelTanksDt from '@/services/dataTransferModules/machineFuelTanksDt'
import useFuelTypes from '@/composables/staticData/useFuelTypes'
const machineFuelTanksDt = new MachineFuelTanksDt()

export default function useMachineFuelTanks() {
	const { t: $t } = useI18n()

	const {
		fuelTypesObj,
	} = useFuelTypes()

	const {
		loadEntityFlags: flags,

		entities: fuelTanks,
		getEntities: getMachineFuelTanks,

		createEntity: createMachineFuelTank,

		entity: fuelTank,
		getEntity: getMachineFuelTank,

		patchEntity: updateMachineFuelTank,
		updateEntity: fullUpdateMachineFuelTank,

		deleteEntity: deleteMachineFuelTank,
	} = useBlProviders(machineFuelTanksDt, {
		postProcessEntityCallback: (entity) => {
			const fuelType = fuelTypesObj.value[entity.type];
			entity.__ao__fuelType = fuelType;
			return entity
		},
		hasParentEntity: true,

		showErrorNotificationForLoadingAllEntities: true,
		errorNotificationTextForLoadingAllEntities: $t('Error loading fuel tanks'),
		showErrorNotificationForCreatingEntity: true,
		errorNotificationTextForCreatingEntity: $t('Fuel tanks loading error'),
		showErrorNotificationForUpdatingEntity: true,
		errorNotificationTextForUpdatingEntity: $t('Fuel tank editing error'),
	})

	return {
		flags,
		fuelTanks,
		fuelTank,

		getMachineFuelTanks,
		getMachineFuelTank,
		createMachineFuelTank,
		deleteMachineFuelTank,
		updateMachineFuelTank,
		fullUpdateMachineFuelTank,
	}
}
